const initialState = {
  campaigns: [
    {
      _id: '1',
      title: 'Youth Leadership Summit',
      causes: ['Youth', 'Education'],
      location: { city: 'Wellington' },
      summary: 'An inspiring weekend to build future leaders.',
      bannerUrl: 'https://via.placeholder.com/600x300?text=Youth+Summit'
    },
    {
      _id: '2',
      title: 'Clean Beach Challenge',
      causes: ['Environment'],
      location: { city: 'Auckland' },
      summary: 'Join our coastlines clean-up movement.',
      bannerUrl: 'https://via.placeholder.com/600x300?text=Clean+Beach'
    }
  ]
}

const campaignReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default campaignReducer
